import * as React from 'react';
import {FunctionComponent} from 'react';
import {Share} from '../../Components/Workout/Generic/Share';
import {FullWorkout, IndoorFullWorkout} from '../../../Models/FullWorkout';
import {IndoorIntervalTable} from '../../Components/Workout/Indoor/IndoorIntervalTable';
import {Claim} from './Claim';
import {FullWorkoutSummary} from '../../Components/Workout/FullWorkoutSummary';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {Loader} from '../../Components/Utils/Loader';
import {SplitTable} from '../../Components/Workout/Indoor/SplitTable';
import {NetworkResult} from '../../../Network/NetworkResult';
import {DownloadedIndoorWorkout} from '../../../Models/DownloadedIndoorWorkout';

interface OwnProps {
    title: string;
    token: string;
    fullWorkout: FullWorkout;
    downloadedIndoorWorkoutResult?: NetworkResult<DownloadedIndoorWorkout>;
}

function hasStrokes(downloadedIndoorWorkout: DownloadedIndoorWorkout): boolean {
    return downloadedIndoorWorkout.workoutIntervals.some((workoutInterval) => {
        return workoutInterval.strokes.length > 0;
    });
}

export const Full: FunctionComponent<OwnProps> = ({title, token, fullWorkout, downloadedIndoorWorkoutResult}) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <h1>{title}</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-lg-9">
                    <FullWorkoutSummary fullWorkout={fullWorkout} />
                    <Claim className="mt-3 d-lg-none" token={token} fullWorkout={fullWorkout} />
                    {fullWorkout.execution_type === WorkoutExecutionType.INDOOR && (
                        <>
                            <IndoorIntervalTable
                                className="mt-3"
                                indoorFullWorkout={fullWorkout as IndoorFullWorkout}
                            />
                            {downloadedIndoorWorkoutResult && (
                                <NetworkRequestStatusView
                                    result={downloadedIndoorWorkoutResult}
                                    loader={() => <Loader className="mt-3" />}
                                    error={() => null}
                                    component={(downloadedIndoorWorkout) =>
                                        hasStrokes(downloadedIndoorWorkout) && (
                                            <>
                                                <SplitTable
                                                    className="mt-3"
                                                    downloadedIndoorWorkout={downloadedIndoorWorkout}
                                                />
                                            </>
                                        )
                                    }
                                />
                            )}
                        </>
                    )}
                </div>
                <div className="col-12 col-lg-3">
                    <Share className="mt-3 mt-lg-0" partialWorkout={fullWorkout} />
                    <Claim className="mt-3 d-none d-lg-block" token={token} fullWorkout={fullWorkout} />
                </div>
            </div>
        </div>
    );
};
